import { LOADING } from "../../constants/constant";
import {
    GET_DELIVERY_TABLE_DATA,
    GET_DELIVERY_TABLE_DATA_SUCCESS,
    GET_DELIVERY_TABLE_DATA_FAILED,
    GET_DELIVERY_TABLE_DATA_RESET 
} from "../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: false,
};

export default function getDeliveryTableDataReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DELIVERY_TABLE_DATA:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_DELIVERY_TABLE_DATA_SUCCESS:
      let filteredData = Object.assign({}, state);
      filteredData.status = action.data.status_message;
      filteredData.isLoading = false;
      filteredData.statusCode = action.data.status_code;
      filteredData.tableData = action.data.data;
      return filteredData;

    case GET_DELIVERY_TABLE_DATA_FAILED:
      return Object.assign({}, state, action.error);

    case GET_DELIVERY_TABLE_DATA_RESET:
      return initialState;

    default:
      return state;
  }
}
